import { useMutation, useQueryClient } from 'react-query';

import { IntegrationType } from 'src/generated/mloop-graphql';

import { ApiVerb, apiPost } from 'src/utils/api';

import { QUERY_KEY } from './types';

interface DeleteIntegrationRequest {
  integration_type: IntegrationType;
}

async function deleteIntegration(data: DeleteIntegrationRequest) {
  const response = await apiPost(ApiVerb.DELETE_INTEGRATION, data);
  return response.data;
}

export default function useIntegrationDelete(integrationType: IntegrationType) {
  const queryClient = useQueryClient();
  return useMutation(() => deleteIntegration({ integration_type: integrationType }), {
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEY]);
      queryClient.invalidateQueries([QUERY_KEY, integrationType]);
    },
  });
}
